import { IKnmOrderGuarantor } from 'APIPackage/KnmModule/interfaces/IKnmOrderGuarantor';

export const getFullNameGuarantor = (guarantor?: IKnmOrderGuarantor) =>
  guarantor?.surname && guarantor.firstName && guarantor.middleName
    ? `${guarantor.surname} ${guarantor.firstName} ${guarantor.middleName}`
    : undefined;
